import Player from '@vimeo/player';
import 'jquery-typeahead';

export default class Hero {
  constructor() {
    this.body = $('body');
    this.hero = $('.hero');
    this.playButton = $('.hero-play-button');
    this.soundButton = $('.hero-sound-button');
    this.iframeContainer = $('#hero-video-vimeo');
    this.videoContainer = $('.hero-video');
    this.vimeoPlayButtonBreakpoint = 352;
    this.searchContainer = $('.hero-searchbar-container');
    this.searchButton = $('.btn-hero-search');
    this.searchForm = $('.hero-searchform');
    this.closeSearchFormButton = $('.hero-searchform .btn-close');
    this.searchField = $('.hero-searchform input[type="text"]');
    this.heroBgCarousel = $('.hero-bg-carousel .owl-carousel');
    this.scrollTo = $('.scroll-to');
  }

  init() {
    if (this.iframeContainer.length > 0) {
      this.initVimeoPlayer();
    }

    if (this.searchButton.length > 0) {
      this.initSearch();
      this.initSearchAutoComplete();
    }

    this.searchForm.on('submit', e => this.handleSearchSubmit(e));

    this.initHeroBgCarousel();
    this.initScrollTo();
  }

  initVimeoPlayer() {
    const options = {
      id: this.iframeContainer.data('vimeo-video-id'),
      // width: 1920,
      // height: 920,
      loop: true,
      background: true,
      autoplay: true,
      muted: true,
    };

    if ($(window).width() < this.vimeoPlayButtonBreakpoint) {
      options.background = false;
      options.autoplay = false;
      options.muted = false;
      options.playsinline = false;

      this.playButton.hide();
      this.videoContainer.css('margin-top', '0px');
    }

    this.vimeoPlayer = new Player(this.iframeContainer, options);
    this.setVideoRatio();

    if (!this.iframeContainer.data('vimeo-autoplay')) {
      this.pauseAndHide();
    }

    this.playButton.on('click', () => {
      this.onPlayButtonClick();
    });

    this.soundButton.on('click', () => {
      this.onSoundButtonClick();
    });
  }

  setVideoRatio() {
    Promise.all([
      this.vimeoPlayer.getVideoWidth(),
      this.vimeoPlayer.getVideoHeight(),
    ]).then((dimensions) => {
      const width = dimensions[0];
      const height = dimensions[1];

      this.videoContainer[0].style.setProperty('--aspect-ratio', height / width);
    });
  }

  pauseAndHide() {
    this.vimeoPlayer.pause();
    this.vimeoPlayer.setCurrentTime(0);
    this.iframeContainer.hide();
  }

  initSearch() {
    this.searchButton.on('click', () => {
      this.onSearchButtonClick();
    });

    this.closeSearchFormButton.on('click', (e) => {
      this.onCloseSearchFormButtonClick(e);
    });

    this.searchField.on('focusin', e => Hero.onSearchFieldInFocus(e));
    this.searchField.on('focusout', e => Hero.onSearchFieldOutOfFocus(e));
  }

  initSearchAutoComplete() {
    if (this.searchField.length) {
      this.searchField.typeahead({
        minLength: 3,
        group: true,
        maxItem: 10,
        groupOrder: ['keywords', 'search'],
        dynamic: true,
        delay: 500,
        highlight: 'any',
        callback: {
          onClick: (node, a, item, event) => {
            event.preventDefault();
            window.location = item.url;
          },
          onLayoutBuiltBefore: (node, query, result, resultHtmlList) => {
            const links = resultHtmlList.find('a');

            $.each(links, (i, a) => {
              if ($(links[i]).children('.item.webshop').length) {
                $(a).addClass('ajax_search_webshop_button');
              }
            });
          },
        },
        template: (query, item) => {
          let prependItem = '';
          let appendItem = '<i class="last-item fas fa-arrow-right"></i>';

          if (item.isExternal && item.itemClass === 'webshop') {
            prependItem = '<img class="webshop-container" src="/wp-content/themes/gp-groot/dist/static/images/webshop-autocomplete.png"><span>';
            appendItem = '</span><button class="btn btn-secondary last-item"><i class="icomoon-shopping-cart"></i> <span>Ga naar onze webshop</span></button>';
          }

          const markup = `
            <div class="item ${item.itemClass}">
              ${prependItem} <span class="title">${item.title}</span> ${appendItem}
            </div>
          `;

          return markup;
        },
        emptyTemplate: '<div class="item"><a class="no-results">Er zijn geen resultaten gevonden voor <strong>{{query}}</strong>.</a></div>',
        source: {
          keywords: {
            ajax: () => ({
              type: 'GET',
              url: '/wp-json/gpgroot/v1/search-keywords',
            }),
            display: 'title',
            href: '{{url}}',
            minLength: 2,
            matcher: (item) => {
              const searchIn = item.title.toLowerCase();
              const searchFor = this.searchField.val().toLowerCase();

              return searchIn.startsWith(searchFor);
            },
          },
          search: {
            display: 'title',
            href: '{{url}}',
            filter: false,
            ajax: () => ({
              type: 'GET',
              url: '/wp-json/gpgroot/v1/search',
              data: {
                s: '{{query}}',
              },
            }),
          },
        },
      });
    }
  }

  onPlayButtonClick() {
    const icon = this.playButton.find('i');
    const buttonText = this.playButton.find('span');

    if (this.playButton.data('muted') === true) {
      this.playAndShow();
      this.vimeoPlayer.setVolume(1);
      this.vimeoPlayer.setCurrentTime(0);
      this.playButton.data('muted', false);

      buttonText.text(buttonText.data('unmuted-text'));
      icon.removeClass(icon.data('muted-class'));
      icon.addClass(icon.data('unmuted-class'));
    } else {
      this.pauseAndHide();
      this.vimeoPlayer.setVolume(0);
      this.playButton.data('muted', true);

      buttonText.text(buttonText.data('muted-text'));
      icon.removeClass(icon.data('unmuted-class'));
      icon.addClass(icon.data('muted-class'));
    }

    this.hero.toggleClass('expanded');
  }

  onSoundButtonClick() {
    const icon = this.soundButton.find('i');
    const buttonText = this.soundButton.find('span');

    if (this.soundButton.data('muted') === true) {
      this.vimeoPlayer.setVolume(1);
      this.soundButton.data('muted', false);

      buttonText.text(buttonText.data('unmuted-text'));
      icon.removeClass(icon.data('muted-class'));
      icon.addClass(icon.data('unmuted-class'));
    } else {
      this.vimeoPlayer.setVolume(0);
      this.soundButton.data('muted', true);

      buttonText.text(buttonText.data('muted-text'));
      icon.removeClass(icon.data('unmuted-class'));
      icon.addClass(icon.data('muted-class'));
    }
  }

  playAndShow() {
    this.iframeContainer.show();
    this.vimeoPlayer.play();
  }

  onSearchButtonClick() {
    this.body.addClass('in-search-mode');

    this.searchButton.addClass('hide');
    this.searchForm.addClass('show');
    this.searchField.focus();
  }

  onCloseSearchFormButtonClick(event) {
    event.preventDefault();

    this.body.removeClass('in-search-mode');
    this.searchButton.removeClass('hide');
    this.searchForm.removeClass('show');
  }

  static onSearchFieldInFocus(event) {
    const field = $(event.currentTarget);
    field.parent().addClass('in-focus');
  }

  static onSearchFieldOutOfFocus(event) {
    const field = $(event.currentTarget);
    field.parent().removeClass('in-focus');
  }

  handleSearchSubmit(e) {
    e.preventDefault();

    if (($('.typeahead__list').length === 0 || $('.typeahead__list').hasClass('empty')) && this.searchField.val()) {
      window.location = `/?s=${this.searchField.val()}`;
    }
  }

  initHeroBgCarousel() {
    if (!this.heroBgCarousel && this.heroBgCarousel.children().length === 1) return;

    this.heroBgCarousel.owlCarousel({
      items: 1,
      nav: false,
      dots: false,
      autoplay: true,
      autoplayTimeout: 2000,
      loop: true,
      autoWidth: true,
      mouseDrag: false,
      touchDrag: false,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
    });
  }

  initScrollTo() {
    this.scrollTo.on('click', ((e) => {
      let scrollTo = false;
      let deduct = 0;

      const header = document.querySelector('header.header');
      const hasHeroWithFancyboxes = document.querySelectorAll('.hero.with-fancyboxes').length;

      if (header) {
        deduct += header.offsetHeight;
      }

      if (!hasHeroWithFancyboxes && $('.hero-children-container').length) {
        scrollTo = $('.hero-children-container').offset().top;
      } else {
        const parentRow = e.currentTarget.closest('.vc_row:not(.vc_inner)');

        if (parentRow) {
          let nextRow = parentRow.nextElementSibling;

          while (nextRow && !nextRow.matches('.vc_row')) {
            nextRow = nextRow.nextElementSibling;
          }

          if (nextRow) {
            scrollTo = $(nextRow).offset().top;
          }
        }
      }

      if (scrollTo) {
        scrollTo -= deduct;
        scrollTo += 2; // to make sure bottom of the curve is not visible

        $([document.documentElement, document.body]).animate({
          scrollTop: scrollTo,
        }, 2000);
      }
    }));
  }
}
